import React from 'react';
import styles from './InventoryAging.module.scss';
import DataTable from 'react-data-table-component';
import FilterInTable from '../../../../Manage/FilterInTable';

const data = [
    {
        id: 1,
        productId: '001',
        productName: 'Fitness Tracker',
        below30Days: 40,
        Above30to60Days: 20,
        Above60to90Days: 10,
        Above90Days: 5,
        totalValue: '$2,000',
        action: 'Promotion',
    },
    {
        id: 2,
        productId: '001',
        productName: 'Fitness Tracker',
        below30Days: 40,
        Above30to60Days: 20,
        Above60to90Days: 10,
        Above90Days: 5,
        totalValue: '$2,000',
        action: 'Promotion',
    },
    {
        id: 3,
        productId: '001',
        productName: 'Fitness Tracker',
        below30Days: 40,
        Above30to60Days: 20,
        Above60to90Days: 10,
        Above90Days: 5,
        totalValue: '$2,000',
        action: 'Promotion',
    },
    {
        id: 4,
        productId: '001',
        productName: 'Fitness Tracker',
        below30Days: 40,
        Above30to60Days: 20,
        Above60to90Days: 10,
        Above90Days: 5,
        totalValue: '$2,000',
        action: 'Promotion',
    },
    {
        id: 5,
        productId: '001',
        productName: 'Fitness Tracker',
        below30Days: 40,
        Above30to60Days: 20,
        Above60to90Days: 10,
        Above90Days: 5,
        totalValue: '$2,000',
        action: 'Promotion',
    },
];

const columns = [
    {
        name: 'Product ID',
        selector: (row) => row.productId,
        sortable: true,
        minWidth: "160px",
    },
    {
        name: 'Product Name',
        selector: (row) => row.productName,
        sortable: true,
        width: '220px',
    },
    {
        name: '0-30 Days',
        selector: (row) => row.below30Days,
        sortable: true,
        minWidth: "160px",
    },
    {
        name: '31-60 Days',
        selector: (row) => row.Above30to60Days,
        sortable: true,
        minWidth: "160px",
    },
    {
        name: '61-90 Days',
        selector: (row) => row.Above60to90Days,
        sortable: true,
        minWidth: "160px",
    },
    {
        name: '91+ Days',
        selector: (row) => row.Above90Days,
        sortable: true,
        minWidth: "160px",
    },
    {
        name: 'Total Value',
        selector: (row) => row.totalValue,
        sortable: true,
        minWidth: "160px",
    },
    {
        name: 'Action Required',
        selector: (row) => row.action,
        sortable: true,
        minWidth: "200px",
    },
];

const customStyles = {
    headRow: {
        style: {
            backgroundColor: '#FBBD34',
            color: '#FFFFFF',
            fontSize: '16px',
            fontWeight: '600',
            borderBottom: 'none',
        },
    },
    headCells: {
        style: {
            paddingLeft: "20px",
            paddingRight: "20px",
            div: {
                whiteSpace: "normal",
                overflow: "visible",
            },
        },
    },
    cells: {
        style: {
            fontSize: '15px',
            padding: '15px 20px',
            div: {
                whiteSpace: "normal !important",
                overflow: "visible !important",
            },
        },
    },
};

const InventoryAging = () => {

    return (
        <div className={styles.mainContainer}>
            <h4 className={styles.sectionHeading}>Inventory Aging Report</h4>

            <div className={styles.filterTableContainer}>

                <FilterInTable componentName={"Inventory Aging Report"} />

                <div className={styles.table}>
                    <DataTable
                        columns={columns}
                        data={data}
                        pagination
                        highlightOnHover
                        customStyles={customStyles}
                    />
                </div>
            </div>
        </div>
    )
}

export default InventoryAging;